<script>
export default {
    props: [
        'openModal',
        'setActiveView',
        'backToMicrosite',
        'isFromQmi'
    ],
    mounted() {
        this.$eventsBus.$on('switch-to-detail', ($event) => {
            this.$forceUpdate();
        });
    }
};
</script>
